import BaseModel from '@/models/list/base';

import constants from './constants';
import glossary from './glossary';

import upperFirst from 'lodash/upperFirst';
import camelCase from 'lodash/camelCase';

export default class Template extends BaseModel {
  constructor(item = {}, url) {
    super(item, url);

    this.user_id = item.user_id;
    this.event_id = item.event_id;
    this.name = item.name;
    this.type = item.type; // TOURNAMENT_MEMBER_PRIZE_PLACE
    this.orientation = item.orientation;
    this.template = item.template;

    this.is_system = item.is_system ?? false;

    this.template_type = item.template_type;
    if (this.is_system) {
      this.template_type = Template.constants.TEMPLATE_TYPES.SYSTEM;
    } else if (item.user_id && !item.event_id) {
      this.template_type = Template.constants.TEMPLATE_TYPES.USER;
    }

    this.certificate_type = item.certificate_type;

    this.image = item.image || undefined;
  }

  get metaTemplateType() {
    const { template_type } = this;

    return {
      ...Template.glossary.TEMPLATE_TYPES_DATA[template_type],
      ...Object.entries(Template.constants.TEMPLATE_TYPES)
        .reduce((acc, [key, value]) => {
          const keyName = upperFirst(camelCase(key));
          return {
            ...acc,
            [`is${keyName}`]: value === template_type,
          };
        }, {}),
    };
  }

  static get constants() {
    return constants;
  }

  static get glossary() {
    return glossary;
  }
}
